import React from 'react';
import propTypes from 'prop-types';
import ControlledDateInput from '@/components/common/form/ControlledDateInput';
import ControlledTextField from '@/components/common/form/ControlledTextField';
import ControlledTextSelectField from '@/components/common/form/ControlledTextSelectField';
import RelationStatus from '@/constants/constituents/RelationStatus';
import translate from '@/lib/intl/translate';

const RelationStatusOptions = [
  {
    value: RelationStatus.CURRENT,
    text: translate('RELATION_STATUS_CURRENT'),
  },
  {
    value: RelationStatus.FORMER,
    text: translate('RELATION_STATUS_FORMER'),
  },
];

function JobRelationshipForm({ control }) {
  return (
    <div className="grid grid-cols-1 gap-x-3 gap-y-2 md:grid-cols-2">
      <ControlledTextField
        control={control}
        className="md:col-span-1"
        defaultValue=""
        id="relation-label"
        label={translate('RELATION_JOB_TITLE_INPUT_TITLE')}
        name="relationLabel"
      />
      <ControlledTextSelectField
        control={control}
        formControlProps={{ className: 'md:col-span-1' }}
        defaultValue=""
        labelId="add-relation-relationship-status-label"
        id="relation--status"
        label={translate('RELATION_STATUS_INPUT_TITLE_EMPLOYMENT')}
        name="relationStatus"
        items={RelationStatusOptions}
      />
      <div className="md:col-span-1">
        <ControlledDateInput
          control={control}
          label={translate('RELATION_RELATIONSHIP_START_DATE_LABEL')}
          id="relationship-start-date"
          name="relationshipStartDate"
        />
      </div>
      <div className="md:col-span-1">
        <ControlledDateInput
          control={control}
          label={translate('RELATION_RELATIONSHIP_END_DATE_LABEL')}
          id="relationship-end-date"
          name="relationshipEndDate"
        />
      </div>
    </div>
  );
}

JobRelationshipForm.propTypes = {
  control: propTypes.object.isRequired,
};

export default JobRelationshipForm;
